/* React */
import React from "react";

/* Components */
import InsightsFilterSelect from "src/components/insights/insights-filter/insights-filter-select/InsightsFilterSelect";
import TimePeriod from "src/components/insights/insights-filter/time-period/TimePeriod";
import CareSiteMultiSelect from "src/components/insights/insights-filter/care-site-multi-select/CareSiteMultiSelect";

/* Utils */
import { capitalizeCamelCaseFirstLetter } from "src/utils/helper/string-transformation";

/* Interfaces */
import {
  FilterComponentType,
  FilterProps,
  InsightsFilterProps,
  FilterType,
  TimePeriodProps,
} from "src/shared/interfaces/insights-filter/InsightsFilter";

interface HelperProps<T = any> {
  itemKey: FilterType;
  item: FilterProps<T>;
  handleValue: (
    key: FilterType,
    value?: string | TimePeriodProps
  ) => void;
  insightsFilter: InsightsFilterProps;
}

export const renderFilterComponent = ({
  itemKey,
  item,
  handleValue,
  insightsFilter,
}: HelperProps): React.ReactNode => {
  if (!item.show) return null;

  switch (item.componentType) {
    case FilterComponentType.DROPDOWN:
      return (
        <InsightsFilterSelect
          key={itemKey}
          itemKey={itemKey}
          item={item as FilterProps<string>}
          label={capitalizeCamelCaseFirstLetter(itemKey)}
          disabled={item.disabled}
          handleItem={handleValue}
        />
      );
    case FilterComponentType.SLIDER:
      return (
        <TimePeriod
          key={itemKey}
          item={
            insightsFilter.timePeriod as FilterProps<TimePeriodProps>
          }
          handleValue={handleValue}
        />
      );
    case FilterComponentType.MULTI_SELECT:
      return (
        <CareSiteMultiSelect
          key={itemKey}
          item={item as FilterProps<string[]>}
        />
      );
    default:
      return null;
  }
};
